import React from 'react';
import { ConfirmDialogGlobalStyle } from './confirmation';
import { DropzonePlaceholderGlobalStyle } from './DropzonePlaceholder';
import { SweetAlertGlobalStyle } from './popups';
import { ReactSelectGlobalStyle } from './ReactSelect';

/**
 * Mounts every app-wide library createGlobalStyle once, so App.js renders only this. Add new global styles
 * here, not in App.js. Each must be mounted exactly once: every mounted copy injects its rules again.
 * Order is injection order, so a later style wins over an earlier one at equal specificity.
 */
function GlobalStyles() {
    return (
        <>
            <ConfirmDialogGlobalStyle />
            <SweetAlertGlobalStyle />
            <ReactSelectGlobalStyle />
            <DropzonePlaceholderGlobalStyle />
        </>
    );
}

export default GlobalStyles;
